import { render, staticRenderFns } from "./invitation-newuser1.vue?vue&type=template&id=5b447bc6&scoped=true&"
import script from "./invitation-newuser1.vue?vue&type=script&lang=js&"
export * from "./invitation-newuser1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b447bc6",
  null
  
)

export default component.exports